module.exports = __webpack_public_path__ + "img/user.750e82ba.svg";